import { useCallback, useContext } from 'react';
import { useEditorCapability, useEditorConfigurationKey } from 'composer-data/channel-capabilities/public/hooks';
import AttachmentButton from '../plugins/AttachmentButton';
import { droppedFile } from '../../../usage-tracking/events/editorInteractions';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';
import { EMAIL_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const useFileAttachmentConfig = ({
  attachments,
  threadId,
  handleAttachmentChange,
  renderExistingFileSelect,
  fileUploadsInProgCount,
  uploadFile,
  uploadDroppedFiles
}) => {
  const editorConfigKey = useEditorConfigurationKey();
  const outgoingAttachmentTypes = useEditorCapability('outgoingAttachmentTypes');
  const {
    trackEvent
  } = useContext(EditorTrackerContext);
  const hasFileOutgoingAttachmentType = outgoingAttachmentTypes.includes('FILE');
  const allowedFileAttachmentMimeTypes = useEditorCapability('allowedFileAttachmentMimeTypes') || [];
  const maxFileAttachmentCount = useEditorCapability('maxFileAttachmentCount') || 0;
  const onDropNonImage = useCallback((_fileinfo, file) => {
    uploadDroppedFiles([file]);
    trackEvent(droppedFile());
  }, [uploadDroppedFiles, trackEvent]);
  if (!hasFileOutgoingAttachmentType) {
    return {};
  }
  return {
    FILE_ATTACHMENTS: {
      renderAttachmentButton: /*#__PURE__*/_jsx(AttachmentButton, {
        attachments: attachments,
        attachmentCountLimit: maxFileAttachmentCount,
        onAttach: handleAttachmentChange,
        renderExistingFileSelect: renderExistingFileSelect,
        threadId: threadId,
        fileUploadsInProgCount: fileUploadsInProgCount,
        uploadFile: uploadFile
      })
    },
    FILE_DROP: {
      fileDropConfig: {
        allowedFileTypes: allowedFileAttachmentMimeTypes,
        onDropNonImage,
        skipNonImageUpload: true,
        fileOptions: {
          access: editorConfigKey === EMAIL_GENERIC_CHANNEL_ID ? 'HIDDEN_IN_APP_SENSITIVE' : undefined
        }
      }
    }
  };
};